import React from "react";

import { Grid } from "@material-ui/core";
import { RegisterUserSubformProps } from "./RegisterUserSubformProps";
import { UserInfoField } from "common/components";

export const RegisterUserProofSubform = (props: RegisterUserSubformProps) => (
  <Grid container spacing={5} direction="column">
    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="address" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="addressZipcode" {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="addressCity" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField
          id="addressCountry"
          className="autocomplete"
          {...props}
        />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="idType" {...props} />
      </Grid>

      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField id="idDocumentNumber" {...props} />
      </Grid>
    </Grid>

    <Grid container item direction="row" spacing={5}>
      <Grid item xs={12} lg={6} md={6} sm={6}>
        <UserInfoField
          id="idDocumentCountry"
          className="autocomplete"
          {...props}
        />
      </Grid>

      <Grid item xs={12} sm={6}>
        <UserInfoField id="passportIssuingAgency" {...props} />
      </Grid>
    </Grid>
  </Grid>
);
